import React, { useState } from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

const Official = () => {
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(null);

    const handleDownload = async (fileName, displayName) => {
        try {
            const response = await fetch(`/reports/${fileName}`, {
                method: 'HEAD',
            });

            if (response.ok) {
                setError(null);
                const link = document.createElement('a');
                link.href = `/reports/${fileName}`;
                link.download = displayName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                setError('Файл не найден на сервере');
            }
        } catch (err) {
            setError('Ошибка при попытке скачать файл');
            console.error(err);
        }
    };

    const update = async () => {
        setStatus("Обновление...");

        try {
            const response = await axios.post("/feds_updating");
            const { output } = response.data;

            if (output.trim() === "Feeds categories updated") {
                setStatus("Фиды обновлены");
            } else {
                setStatus("Ошибка при выполнении команды");
                console.error(output);
            }
        } catch (error) {
            setStatus("Ошибка при выполнении команды");
            console.error(error);
        }
    };

    return (
        <>
            <div style={{ margin: '20px 0 0 20px' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleDownload('prices.csv', 'prices.csv')}
                >
                    Скачать выгрузку CSV
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    style={{marginLeft: '15px'}}
                    onClick={() => handleDownload('json_prices.json', 'json_prices.json')}
                >
                    Скачать выгрузку JSON
                </Button>
                {error && (
                    <Typography variant="body1" color="error">
                        {error}
                    </Typography>
                )}
            </div>
            <div style={{ margin: "10px" }}>
                <Typography
                    variant="body1"
                    style={{
                        marginLeft: "15px",
                        fontWeight: "700",
                        fontSize: "16px",
                        color:
                            status === "Обновление..."
                                ? "blue"
                                : status === "Фиды обновлены"
                                    ? "green"
                                    : "red",
                    }}
                >
                    {status}
                </Typography>
                <Button
                    style={{ margin: "15px" }}
                    variant="contained"
                    color="primary"
                    onClick={update}
                >
                    Обновить фиды
                </Button>
            </div></>
    );
};

export default Official;
